import { useRoutes } from 'react-router-dom';
import { ScreenError404 } from './components/screens';
import { routes } from './routes';
import { RouteGuard } from '@/hoc';
import { useEffect } from 'react';
import { clearLocalStorageOnUpdate } from './lib/utils';

export const App = () => {
  useEffect(() => {
    clearLocalStorageOnUpdate();
  }, []);

  return (
    <RouteGuard>
      {useRoutes([
        ...routes(),
        {
          path: '*',
          element: <ScreenError404 title="not.found.page" withoutNavigate />,
        },
      ])}
    </RouteGuard>
  );
};
